/*

PARA CHAMADA DE COMPONENTE:
import CardPedido from '~/util/cardPedido/.mixins';

PARAMETROS QUE DEVEM SER PASSADOS. EX:
const params = {
      nr_pedido: 123,
      dt_agendamento: new Date(),
      ds_status: "pendente / confirmado / recusado",
      ds_situacao: "a",
      ds_filial: "101 - Estrada da vargem do João Pinto, Extrema - MG",
      dt_sugerida: new Date(),
      ds_msg: "A tokstok solicitou alteração na data de entrega deste pedido",
      ds_opcao_pag: "120 dias",
      bt_component: [
                      {
                        label: "VER DETALHE DA ENTREGA",
                        variant:"contained",
                        handler: () => {
                            console.log("Click agendamento!");
                        }
                      },
                      {
                        label: "ALTERAR OPÇÃO DE PAGAMENTO",
                        variant:"contained",
                        handler: () => {
                            console.log("Click agendamento!");
                        }
                      },
                      {
                        label: "IMPRIMIR PROTOCOLO",
                        variant:"outlined",
                        handler: () => {
                            console.log("Click agendamento!");
                        }
                    },
                    ],
      Ds_msg_alert: (className) => {
          return (
              <div style={{color: "red"}}>
                  A confirmação de agendamento deste pedido irá <b>expirar em 3 dias</b>
              </div>
          );
      }
  };

CHAMADA DE RENDERIZAÇÃO
<CardPedido {...params}/>

*/

//natives
import React from "react";
import moment from "moment";
import { Card, Typography, Grid, Button, Tooltip } from "@material-ui/core";
import "moment/locale/pt-br";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//css
import Styles from "./styles";
const useStyles = Styles();

export default (props) => {
  const {
    nr_pedido,
    cd_filial,
    dt_agendamento,
    ds_status,
    ds_situacao,
    ds_filial,
    dt_sugerida,
    ds_msg,
    bt_component,
    Ds_msg_alert,
    ds_opcao_pag,
    motivo_recusa,
  } = props;

  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          {nr_pedido != null && (
            <Typography variant="h6">{`Nº pedido: ${nr_pedido}`}</Typography>
          )}
          {dt_agendamento != null && (
            <Typography variant="h6" noWrap>
              {`Data de agendamento: ${moment(dt_agendamento, "DD/MM/YYYY").format("DD/MM/YYYY - dddd")}`}
            </Typography>
          )}
          {ds_status != null && (
            <Typography color="textSecondary">
              <b>{`Status: `}</b>
              {ds_status}
            </Typography>
          )}
          {ds_situacao != null && (
            <Typography color="textSecondary">
              <b>{`Situação: `}</b>
              {ds_situacao}
            </Typography>
          )}
          {ds_filial != null && (
            <Typography color="textSecondary">
              <b>{`Filial: `}</b>
              {ds_filial}
            </Typography>
          )}
          {motivo_recusa != null && (
            <Typography color="textSecondary">
              <b> Motivo da recusa: </b>
              {motivo_recusa}
            </Typography>
          )}
          {dt_sugerida != null && (
            <Typography color="textSecondary">
              <b>{`Data sugerida: `}</b>
              {moment(dt_sugerida, "DD/MM/YYYY").format("DD/MM/YYYY - dddd")}
            </Typography>
          )}
          {ds_opcao_pag != null && (
            <Typography color="textSecondary">
              <b>{`Opção de pagamento: `}</b>
              {ds_opcao_pag}
            </Typography>
          )}
        </Grid>
        <Grid item xs={6} className={classes.view_card_right}>
          <Grid item xs={12}>
            {ds_msg != null && (
              <Typography className={classes.lb_msg} color="textSecondary">
                <b>{ds_msg}</b>
              </Typography>
            )}
          </Grid>
          <Grid
            item
            container
            style={{ verticalAlign: "middle" }}
            align-content="center"
            alignItems="center"
            xs={12}
          >
            {bt_component != null &&
              bt_component.map((element, i) => {
                const displayPermission =
                  element.display == null || element.display ? "flex" : "none";
                return (
                  <Tooltip
                    key={i}
                    arrow={true}
                    title={element.tooltip ? element.tooltip : ""}
                  >
                    <Grid
                      item
                      xs={12}
                      justifyContent="center"
                      align-content="center"
                      alignItems="center"
                      container
                    >
                      <Button
                        className={classes.lb_button}
                        variant={element.variant}
                        color="primary"
                        style={{ display: displayPermission }}
                        disabled={
                          element.disabled ? element.disabled : false
                        }
                        // É necessário que o element.handler receba essas props!
                        // Pois é a única forma do modalTable receber as props do Card do Pedido
                        onClick={() => element.handler(props)}
                        startIcon={
                          element.startIcon ? (
                            <FontAwesomeIcon icon={element.startIcon} />
                          ) : null
                        }
                      >
                        {element.label}
                      </Button>
                    </Grid>
                  </Tooltip>
                );
              })}
          </Grid>
          <Grid style={{ minHeight: "15%" }} item xs={12}>
            {Ds_msg_alert != null && <Ds_msg_alert className={classes.lb_msg_alert} />}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};
